import { useState, useCallback, useRef, useEffect } from 'react';
import API from 'api/api';
import { translateApiError } from 'i18n/translateApiError';

export function useGetUserById() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);
  // Cleanup ref on unmount
  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const getUserById = useCallback(async (userId) => {
    if (!userId) {
      console.error('No userId provided to getUserById');
      return false;
    }

    try {
      if (mountedRef.current) {
        setLoading(true);
        setError(null);
      }

      const res = await API.get(`/users/id/${userId}`);
      console.log(res.data);
      return res.data;
    } catch (err) {
      if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED')
        return false;
      console.error('Failed to get user by id:', err);
      if (mountedRef.current) {
        setError(translateApiError(err, 'Failed to get user by id'));
      }
      return false;
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  return { getUserById, loading, error };
}
